export const STORE_REQUEST_STATUS = {
    idle: 'IDLE',
    loading: 'LOADING',
    loaded: 'LOADED',
    error: 'ERROR',
};
export const INITIAL_STATUS = {
    [STORE_REQUEST_STATUS.idle]: true,
    [STORE_REQUEST_STATUS.loading]: false,
    [STORE_REQUEST_STATUS.loaded]: false,
    [STORE_REQUEST_STATUS.error]: false,
};
